<template>
  <div class="collection-filter-bar-wrapper sticky">
    <div class="collection-filter-bar flex justify-between items-center container">
      <button
        class="mobile-filters-trigger filter-group__trigger"
        @click="openMobileFilters"
      >
        All filters
        <span
          v-if="totalActiveFilters > 0"
          class="color-red"
        >
          {{ totalActiveFilters }}
        </span>
        <FiltersIcon />
      </button>
      <div class="collection-filters__list filters hidden md:flex">
        <CollectionFilter
          v-for="(filter) in collectionFilters"
          :key="`filter-${filter.label}`"
          :filter="filter"
        />
      </div>

      <div class="collection-sorting flex items-center">
        <span class="hidden sm:inline-block xs">
          {{ pageSizeText }}
        </span>

        <v-select
          id="SortBy"
          v-model="currentSortBy"
          label="label"
          :options="sortOptions"
          :clearable="false"
          :searchable="false"
          class="collection__sortby"
          aria-describedby="a11y-refresh-page-message"
        >
          <template #selected-option="option">
            <div class="filter-group__trigger">
              {{ option.label }}
              <ChevronRightIcon class="ml-auto" />
            </div>
          </template>
        </v-select>
      </div>
    </div>
  </div>

  <transition name="slideout">
    <div
      v-if="filterSlideoutIsOpen"
      v-cloak
      class="collection-filters-wrapper md:hidden"
      data-close
      @click="closeMobileFilters"
    >
      <div class="collection-filters">
        <div class="collection-filters__header flex justify-between items-center">
          <h2 class="h5">
            Filters
          </h2>
          <button
            class="close-btn xs font-semibold flex items-center"
            data-close
            @click="closeMobileFilters"
          >
            Close
            <CloseIcon />
          </button>
        </div>
        <div class="collection-filters__list filters">
          <CollectionFilter
            v-for="(filter) in collectionFilters"
            :key="`filter-${filter.label}`"
            :filter="filter"
          />
        </div>

        <div class="collection-filters__footer flex ites-center">
          <button
            v-if="totalActiveFilters > 0"
            class="underline sm font-medium"
            @click="clearFilters"
          >
            Clear all ({{ totalActiveFilters }})
          </button>
          <button
            class="btn btn--black grow"
            data-close
            @click="closeMobileFilters"
          >
            {{ totalActiveFilters > 0 ? 'Show results' : 'Continue shopping' }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useCollectionStore } from '../pinia/CollectionStore'

import ChevronRightIcon from '../icons/chevron-right'
import FiltersIcon from '../icons/filters-icon'
import CloseIcon from '../icons/close-icon'

import CollectionFilter from './collection-filter'

export default {
  components: {
    ChevronRightIcon,
    FiltersIcon,
    CloseIcon,
    CollectionFilter
  },
  data () {
    return {
      currentSortBy: null
    }
  },
  computed: {
    ...mapState (useCollectionStore, [
      'collectionFilters',
      'sortBy',
      'sortOptions',
      'pagination',
      'totalActiveFilters',
      'filterSlideoutIsOpen',
      'productCount'
    ]),
    pageSizeText () {
      return `${this.productCount} product${this.productCount > 1 ? 's': ''}`
    }
  },
  watch: {
    currentSortBy (newSortBy) {
      this.changeSorting(newSortBy.value)
    }
  },
  mounted () {
    this.setDefaultSortBy()
    this.clickOffTriggerListener()
  },
  methods: {
    ...mapActions (useCollectionStore, [
      'closeFilterDropdown',
      'changeSorting',
      'clearFilters',
      'openMobileFilters',
      'closeMobileFilters'
    ]),
    setDefaultSortBy () {
      this.currentSortBy = this.sortOptions.find(option => option.value === this.sortBy)
    },
    clickOffTriggerListener () {
      document.addEventListener('click', e => {
        if (!e.target.closest('[data-filter]')) this.closeFilterDropdown()
      })
    },
  }
}
</script>
